import React from "react";
import "./VenueApiKeyFlagMultipleValuesInput.styles.scss";
import { Autocomplete, TextField } from "@mui/material";
import { VenueApiKeyFlag } from "@pulse-ui/codegen/generated_ts/types";

const VenueApiKeyFlagMultipleValuesInput = ({
  label,
  value,
  onChange,
  containerClassNames,
  labelClassNames,
  inputClassNames,
  disabled,
}: {
  label: string;
  value: string[];
  onChange: (
    e: React.SyntheticEvent<Element, Event>,
    value: any,
    reason: any
  ) => void;
  containerClassNames: string;
  labelClassNames: string;
  inputClassNames: string;
  type?: string;
  disabled?: boolean;
  copyIcon?: any;
  copyToClipboard?: (text: string, name: string) => Promise<void>;
} & Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "onChange" | "value"
>) => {
  const options = Object.keys(VenueApiKeyFlag).filter((key) =>
    isNaN(Number(key))
  );

  return (
    <div className={containerClassNames}>
      <p
        className={`${labelClassNames} venue-api-key-flag-multiple-values-input-label`}
      >
        {label}
      </p>
      <Autocomplete
        multiple
        value={value}
        className={`multiple-values-input ${inputClassNames}`}
        options={options}
        getOptionKey={(option: any) => option}
        getOptionLabel={(option: any) => option}
        isOptionEqualToValue={(option, value) => option == value}
        defaultValue={[]}
        filterSelectedOptions
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={
              value.length > 0 ? "" : "Select venue api key flags..."
            }
          />
        )}
        onChange={onChange}
        disabled={disabled}
        style={{ color: `${disabled ? "#939db6" : "#e8eaef"}` }}
      />
    </div>
  );
};

export default VenueApiKeyFlagMultipleValuesInput;
